import React, {Component} from 'react';
import Card from '../../common/card-grid/Card';
import {
  Button,
  Wrapper,
  Container,
  List,
  Row,
  Item,
  Input,
  selectAll,
  selectNone,
  select,
  isSelected,
  getFilteredData,
} from '../../settings/Select';
import {FILTER_NONE, FILTER_ALL} from '../../../constants/filters';
import gql from 'graphql-tag';
import {Query, withApollo} from 'react-apollo';
import PRODUCTS from '../../../constants/products';
import Loading from '../Loading';
import Error from '../Error';

const productsSettingsQuery = gql`
  query productsSettings($input: SettingsQueryInput!) {
    products {
      id
      name
      workplace {
        id
        name
      }
    }
    settings(input: $input) {
      id
      products {
        type
        ids
      }
    }
  }
`;

class ProductFilter extends Component {
  state = {
    search: '',
  };

  render() {
    const input = {favoriteId: this.props.favoriteId};
    return (
      <Query query={productsSettingsQuery} variables={{input}}>
        {({loading, error, data}) => {
          if (loading)
            return (
              <Card>
                <Loading />
              </Card>
            );
          if (error) return <Error>{error.message}</Error>;
          const filterProducts = getFilteredData(data.products, this.state.search);
          return (
            <Card>
              <Wrapper>
                <Button
                  active={data.settings.products.type === FILTER_ALL}
                  onClick={() => selectAll(this, data.products, 'id', 'products')}>
                  {PRODUCTS.find((t) => t.key === FILTER_ALL).label}
                </Button>
                <Button
                  active={data.settings.products.type === FILTER_NONE}
                  onClick={() => selectNone(this, data.products, 'id', 'products')}>
                  {PRODUCTS.find((t) => t.key === FILTER_NONE).label}
                </Button>
              </Wrapper>
              <Input
                placeholder={'Search products'}
                value={this.state.products}
                onChange={(e) => this.setState({search: e.target.value})}
              />
              <Container>
                <List
                  itemCount={filterProducts.length}
                  renderItem={({index, style}) => (
                    <Row
                      style={style}
                      key={index}
                      onClick={() =>
                        select(this, data.settings.products, filterProducts[index].id, data.products, 'id', 'products')
                      }
                      selected={isSelected(data.settings.products, filterProducts[index].id)}>
                      <Item>
                        {filterProducts[index].name} ({filterProducts[index].workplace.name})
                      </Item>
                    </Row>
                  )}
                />
              </Container>
            </Card>
          );
        }}
      </Query>
    );
  }
}

export default withApollo(ProductFilter);
